export default "__VITE_ASSET__Bk7BR4js__"